import { Component, OnInit } from '@angular/core';
declare var $: any;
import { ApiService } from '.././api.service';
import { Router , ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-client-visetor',
  templateUrl: './client-visetor.component.html',
  styleUrls: ['./client-visetor.component.scss']
})
export class ClientVisetorComponent implements OnInit {

  arre: any;
  show = false;
  add: any = false;
  update: any = false;
  delete: any = false;
  name: any;
  email: any;
  password: any;
  adress: any;
  root: any;
  phone: any;
  control: any;
  rootA: any;
  controlA: any;
  nameU: any;
  emailU: any;
  passwordU: any;
  adressU: any;
  rootU: any;
  phoneU: any;
  controlU: any;
  idUp: any;
  searchName: any;
  rootSearch = 'أبحث بالفرع';
  controlSearch = 'أبحث بالصلاحية';
  notes: any;
  pay: any;
  idDS: any;
  nameD: any;
  idUS: any;
  payU: any;
  notesU: any;
  country: any;
  countryU: any;
  serchCodeSupplier: any = 'أبحث بالكود';
  city: any;
  cityU: any;
  phone2: any;
  phone2U: any;
  serchCodeVisit: any = null;
  type: any = '';
  typeU: any = '';
  areaU: any;
  area: any;
  arre0987: any;
  serchClient: any;
  arreDate: any;
  quotationNS = 'Search By QUotation No';
  supplierA: any;
  shift: any = '';
  interest: any = '';
  occupation: any;
  about: any = '';
  DatePrint: any;
  TimePrint: any;
  ShiftPrint: any;
  ClientPrint: any;
  OccupationPrint: any;
  AdressPrint: any;
  MobilePrint: any;
  EmailPrint: any;
  AoutPrint: any;
  InterestPrint: any;
  NotesPrint: any;
  constructor(private toastr: ToastrService,private _ApiService: ApiService , private _Router: Router, private _AppComponent: AppComponent, private _Route: ActivatedRoute ) {
    this._AppComponent.activeU = '';
    this._AppComponent.activeR = '';
    this._AppComponent.activeS = '';
    this._AppComponent.activeI = '';
    this._AppComponent.activeC = '';
    this._AppComponent.activeP = '';
    this._AppComponent.activeCu = '';
    this._AppComponent.activeCR = '';
    this._AppComponent.activeH = '';
    this._AppComponent.activeO = '';
    this._AppComponent.activeCE = '';
    this._AppComponent.activeCV = '';
    this._AppComponent.activeSE = '';
    this._AppComponent.activeSEB = '';
    this._AppComponent.activeCuO = '';
    this._AppComponent.activeCuOStore = '';
    this._AppComponent.activeHRE = '';
    this._AppComponent.activeHReport = '';
    this._AppComponent.activeCVV = 'active';
    this._AppComponent.activeCVEm = '';
    this._AppComponent.activeCVEmAttendances = '';
    this._AppComponent.activeCVEmAttendancesSalary = '';
    this._AppComponent.activeCVEmPermession = ''
    this._AppComponent.activeHReportAccounts = '';
    this._AppComponent.activeHReportCashPayments = '';
    this._AppComponent.activeCashReceipts = '';
    this._AppComponent.activeDailyRestrictions = '';
    this._AppComponent.activeGeneralReports = '';
    this._AppComponent.activeHReportPrivate = '';
    this._AppComponent.activeHReportPrivatePaymentsReport = '';

    // this._ApiService.getRoots().subscribe((res)=>{
    //   this.rootA = res;
    // })

    this._ApiService.Profile().subscribe((res)=>{
      if(res.check === true) {
        res.data.forEach((element: any) => {
          if(element.name == 'Visit') {
            if(element.	add_permission === 1) {
              this.add = true;
            }
            if(element.	update_permission === 1) {
              this.update = true;
            }
            if(element.	delete_permission === 1) {
              this.delete = true;
            }
          }

        });
        this._AppComponent.refreshNotification()
        this.show = true;
        this.ngOnInit();
      } else {

        this._Router.navigate([''])
        this.show = false;
      }
    })
    this._ApiService.allSC0Visit().subscribe((res)=>{
      if(res.check === true){
        this.arre = res.data;
        $('.loading').css({display: 'none'});
      } else{
           this.toastr.error(res?.message || 'Server error', 'Error');

      }
    })
    this._AppComponent.goProfile();
   }
   closeUp(){
    $('#upd-up').css({display: 'none'});
    this.nameU = '';
    this.emailU = '';
    this.phoneU = '';
    this.adressU = '';
    this.idUS = '';
    this.cityU = '';
    this.typeU = '';
    this.areaU = '';
  }
  upU(data: any){
    this.nameU = data.name;
    this.emailU = data.email;
    this.phoneU = '0' + data.phone;
    this.adressU = data.adress;
    this.idUS = data.id;
    this.cityU = data.city;
    this.phone2U = '0'+data.phone2;
    this.typeU = data.type;
    this.areaU = data.area;
    $('#upd-up').css({display: 'block'});
  }
  okUp(data: any){
    if(this.nameU == '' || this.nameU == undefined ) {
      alert('Please . Make sure the Name Is entered');
    } else {
      data.id = this.idUS;
      $('.loading').css({display: 'block'});
    this._ApiService.updateSC0(data).subscribe((res)=> {
      if(res === true) {
        this._ApiService.allSC0().subscribe((res)=>{
          this.arre = res.data;
          alert('Updated Done Successfully');
          this.closeUp();
        $('.loading').css({display: 'none'});
        })
      } else {
        alert("Updated Don't Successfully");
        this.closeUp();
        $('.loading').css({display: 'none'});
      }
    })
    }
  }
   delS(id: any , name: any){
    $('#upd-dd').css({display: 'block'});
    this.idDS = id;
    this.nameD = name;
  }
  closedd(){
    $('#upd-dd').css({display: 'none'});
    this.idDS = '';
    this.nameD = '';
  }
  ok(){
    $('.loading').css({display: 'block'});
    var x = this.idDS;
    var e = this.nameD;
    this._ApiService.delSC0F({id: x , name: this.nameD}).subscribe((res)=>{
      if(res === true){
        this._ApiService.allSC0().subscribe((res)=>{
          this.arre = res.data;
          alert('Deleted Done Successfully');
          this.closedd();
          $('.loading').css({display: 'none'});
        })
      } else {
        alert('Deleted Not Successfully\nPlease, if you want to delete this user, you must delete all his pre request on the site');
        this.closedd();
        $('.loading').css({display: 'none'});
      }
    })
  }
  addS(){
    $('#upd').css({display: 'block'});
  }
  close(){
    $('#upd').css({display: 'none'});
    this.name = '';
    this.email = '';
    this.adress = '';
    this.phone = '';
    this.city = '';
  }
  // addS0(data: any){
  //   if(this.name == '' || this.name == undefined) {
  //     alert('Please . Make sure the Name Is entered');
  //   } else {
  //     $('.loading').css({display: 'block'});
  //   this._ApiService.addSCN(data).subscribe((res)=>{
  //     if(res.check === true){
  //       this._ApiService.addSCNAnother(data).subscribe((res)=>{
  //         if(res.check === true){
  //           this._ApiService.allSC0Visit().subscribe((res0)=>{
  //             if(res0.check === true){
  //               this.arre = res0.data;
  //                this.toastr.success('Customer added successfully', 'Success');
  //               this.close();
  //               $('.loading').css({display: 'none'});
  //             } else{
  //                this.close();
  //                $('.loading').css({display: 'none'});
  //                this.toastr.error(res0?.message || 'Server error', 'Error');
  //             }
  //           })
  //         } else {
  //           // alert('This Customer already exists');
  //            this.toastr.success('This Customer already exists', 'Success');
  //           this.close();
  //           $('.loading').css({display: 'none'});
  //         }
  //       })
  //     } else {
  //       this.toastr.success('This Customer already exists', 'Success');
  //       this.close();
  //       $('.loading').css({display: 'none'});
  //     }
  //   })
  //   }
  // }
  addS0(data: any) {
  if (this.name == '' || this.name == undefined) {
    this.toastr.error('Please make sure the Name is entered', 'Error');
    return;
  }

  $('.loading').css({ display: 'block' });

  this._ApiService.addSCN(data).subscribe(
    (res: any) => {
      if (res.check === true) {
        this._ApiService.addSCNAnother(data).subscribe(
          (res2: any) => {
            if (res2.check === true) {
              this._ApiService.allSC0Visit().subscribe(
                (res0: any) => {
                  if (res0.check === true) {
                    this.arre = res0.data;
                    this.toastr.success('Customer added successfully', 'Success');
                  } else {
                    this.toastr.error(res0?.message || 'Failed to load customers', 'Error');
                  }

                  this.close();
                  $('.loading').css({ display: 'none' });
                },
                (error) => {
                  console.error('allSC0Visit error:', error);
                  this.toastr.error(error?.error?.message || 'Server error', 'Error');
                  this.close();
                  $('.loading').css({ display: 'none' });
                }
              );
            } else {
              this.toastr.error(res2?.message || 'This customer already exists', 'Error');
              this.close();
              $('.loading').css({ display: 'none' });
            }
          },
          (error) => {
            console.error('addSCNAnother error:', error);
            this.toastr.error(error?.error?.message || 'Server error', 'Error');
            this.close();
            $('.loading').css({ display: 'none' });
          }
        );
      } else {
        this.toastr.error(res?.message || 'This customer already exists', 'Error');
        this.close();
        $('.loading').css({ display: 'none' });
      }
    },
    (error) => {
      console.error('addSCN error:', error);
      this.toastr.error(error?.error?.message || 'Server error', 'Error');
      this.close();
      $('.loading').css({ display: 'none' });
    }
  );
}
  goFile(event: any){
    $('.loading').css({display: 'block'});
    const formdata = new FormData();
    formdata.append('excel', event.target.files[0])
    this._ApiService.addSCN0(formdata).subscribe((res)=>{
      if(res.check === true) {
        this._ApiService.allSC0().subscribe((res0)=>{
          if(res0.check === true){
            this.arre = res0.data;
             this.toastr.success('Added successfully', 'Success');
            $('.loading').css({display: 'none'});
          } else{
            this.toastr.error(res0?.message || 'Server error', 'Error');
          }
        })
      } else{
        alert('This Customer already exists');
      }
    })
  }
  printert(){
    window.print();
  }
  trigger(){
    $('#excel').trigger('click');
  }
  delS000(id: any){
    // $('.loading').css({display: 'block'});
    // this._ApiService.getPayments({id: id}).subscribe((res)=>{
      // this.arre0987 = res;
      this.serchClient = id;
      $('#upd023').css({display: 'block'});
      // $('.loading').css({display: 'none'});
    // })
  }
  close0093(){
    $('#upd023').css({display: 'none'});
  }
  goDate() {
    $('.loading').css({display: 'block'});
    this._ApiService.allIDReturn({from: $('#fromDG').val(), to: $('#toDG').val()}).subscribe((res)=>{
      if(res.check === true){
        this.arreDate = res.data;
        $('.loading').css({display: 'none'});
      } else{
                   this.toastr.error(res?.message || 'Server error', 'Error');

        $('.loading').css({display: 'none'});
      }
    })
  }
  printQWE(data: any){
    this.DatePrint = data.date;
    this.TimePrint = data.time;
    this.ShiftPrint = data.shift;
    this.ClientPrint = data.name;
    this.OccupationPrint = data.occupation;
    this.AdressPrint = data.adress;
    this.MobilePrint = data.mobile;
    this.EmailPrint = data.email;
    this.AoutPrint = data.social;
    this.InterestPrint = data.interested;
    this.NotesPrint = data.notes;
    $('.asdfg').css({display: 'block'});
    $('.noer').css({display: 'none'});
    setTimeout(() => {
      window.print();
      $('.asdfg').css({display: 'none'});
    $('.noer').css({display: 'block'});
    }, 400);

  }


  ngOnInit(): void {
    let self = this;
    $('.fromDA').val(new Date().toJSON().slice(0,10));
    $('.toDA').val(new Date().toJSON().slice(0,10));
    $('.select2, .js-example-basic-multiple').select2();
    $('.quotationNS').on('select2:select', function (e: any) {
      self.quotationNS = $('.quotationNS').val()
    });
  }

}
